<div class="action-menu"
  [ngClass]="{'action-menu-featured' : isFeatured}">
  @for (item of menuItems; track item) {
    <div
      (click)="onClickItem(item)">
      <div>
        <div class="fad-bichromatic">
          @if (item.icon && !item.icon.fontAwesomeClassName) {
            <sb-icon-img
              [type]="item.icon.type"
              [category]="item.icon.category"
              [name]="item.icon.name"
            [imgUrl]="item.icon.imgUrl"></sb-icon-img>
          }
          @if (item.icon && item.icon.fontAwesomeClassName) {
            <div>
              <i [ngClass]="item.icon.fontAwesomeClassName"></i>
            </div>
          }
          @if (item.linkUrl) {
            <sb-icon name="followLink"
              overrideStyle="solid"
            ></sb-icon>
          }
        </div>
        <div>
          <h3 [innerHtml]="item.label | translate"></h3>
          <div [innerHtml]="item.description | translate"></div>
        </div>
      </div>
      @if (!isFeatured) {
        <div>
          <sb-icon name="chevronRight"></sb-icon>
        </div>
      }
    </div>
  }
</div>
